import { SearchExpression } from '../../../model/search/advanced/SearchExpression';
import { ISearch } from '../../../model/search/ISearch';

import { Factory } from '../../Factory';
import { BaseSearchService } from '../BaseSearchService';

export class SearchService extends BaseSearchService implements IService {
  private $rootScope: IRootScope;
  private configService: any;
  private httpService: any;
  private notificationService: any;
  private lastQuery: String;
  private resource: any;
  private resourceWrapperService: any;

  constructor($rootScope: IRootScope, configService: any, httpService: any, notificationService: any, $resource: any, resourceWrapperService: any) {
    super();
    this.$rootScope = $rootScope;
    this.configService = configService;
    this.httpService = httpService;
    this.notificationService = notificationService;
    this.lastQuery = "";
    this.resourceWrapperService = resourceWrapperService;
    this.resource = $resource;
  }

  public static FormatDateSearch(item) {
    let dateFormat = d3.timeFormat("%Y-%m-%d");
    let startDate = new Date(item.min);
    let endDate = new Date(item.max);

    return ` [${dateFormat(startDate)} TO ${dateFormat(endDate)}]`;
  }

  public Search(project, collection: any, search: ISearch, columnFilters: SearchExpression = new SearchExpression(), sortBy: string = null, sortDirection: any = null, page: number = 1, limit: number = 20): Promise<any> {

    let promise;

    if (collection) {
      promise = this.resourceWrapperService.WrapActions(this.resource(`${this.configService.getServerBaseUrl()}/project/:id/collection/:collectionId/search`, {
        id: "@id",
        collectionId: "@collectionId"
      }, {
        query: {
          method: "POST",
          params: {page: page, limit: limit, query: search.expression, sortBy, sortDirection}
        }
      })).query({
        id: project.id,
        collectionId: collection.id
      }, columnFilters).$promise;

    } else {
      promise = this.resourceWrapperService.WrapActions(this.resource(`${this.configService.getServerBaseUrl()}/project/:id/search`, {
        id: "@id"
      }, {
        query: {
          method: "POST",
          params: {page: page, limit: limit, query: search.expression, sortBy, sortDirection}
        }
      })).query({
        id: project.id
      }, columnFilters).$promise;
    }

    promise.then(() => {
      this.$rootScope.$broadcast("Search.SearchSuccess");
    });

    promise.catch(() => {
      this.$rootScope.$broadcast("Search.SearchError");
    });

    return promise;
  }
}

frontendApp.factory("BasicSearchService", ['$rootScope', 'ConfigService', 'HttpService', 'NotificationService', '$resource', 'ResourceWrapperService', function(rootScope, configService, httpService, notificationService, resource, resourceWrapperService) {
  return new SearchService(rootScope, configService, httpService, notificationService, resource, resourceWrapperService);
}]);
